export const aciMail = {
    iconName: 'mail',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M2 7.443a2.381 2.381 0 012.381-2.38h15.238A2.381 2.381 0 0122 7.442v9.113a2.381 2.381 0 01-2.381 2.38H4.381A2.38 2.38 0 012 16.557V7.443zm2.381-1.428c-.789 0-1.429.64-1.429 1.428v9.113c0 .789.64 1.428 1.429 1.428h15.238c.789 0 1.429-.64 1.429-1.428V7.443c0-.789-.64-1.428-1.429-1.428H4.381z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M3.104 6.21a.476.476 0 01.667-.094l6.866 5.176a2.35 2.35 0 001.413.47 2.35 2.35 0 001.414-.47l6.866-5.176a.476.476 0 01.574.76l-6.866 5.176c-.571.43-1.27.663-1.988.663a3.302 3.302 0 01-1.987-.663L3.197 6.876a.476.476 0 01-.093-.667z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
